import { ErrorState } from "@/components/ErrorState";
import Loader from "@/components/loader/Loader";
import SwapContainer from "@/components/shared/swap/SwapContainer";
import { useSystemWalletDetails } from "@/hooks";
import type { WalletAsset } from "@/interfaces/asset";
import type { SystemWalletType } from "@/interfaces/wallet";
import { queryClient } from "@/services/queryClient";
import { normalizeCurrency } from "@/utils";
import { makeRequest } from "@/utils/makeRequest";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const AdminSwap = () => {
  const { systemType } = useParams();

  const [rates, setRates] = useState([]);

  const [selectedAsset, setSelectedAsset] = useState<WalletAsset>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!systemType) return;
  }, [systemType]);

  const swap = async ({
    networkId,
    fromAssetId,
    toAssetId,
    amount,
    systemType,
    // otp,
    securityCode,
  }: {
    networkId: string;
    fromAssetId: string;
    toAssetId: string;
    amount: string;
    systemType: SystemWalletType;
    // otp: string;
    securityCode: string;
  }) => {
    setIsLoading(true);

    const payload = {
      networkId,
      fromAssetId,
      toAssetId,
      amountFrom: amount,
      systemType,
      // otp,
      securityCode,
    };

    console.log("SWAP PAYLOAD", payload);

    try {
      await makeRequest.post("/blockchain/swap/system", payload);

      await queryClient.invalidateQueries({
        queryKey: ["wallet:details", systemType],
      });
    } finally {
      setIsLoading(false);
    }
  };

  const {
    data: wallet,
    isLoading: isLoadingWallet,
    isError,
    refetch,
  } = useSystemWalletDetails(systemType!);

  const assets: WalletAsset[] = wallet?.assets || [];

  useEffect(() => {
    if (assets.length > 0 && !selectedAsset) {
      setSelectedAsset(assets[0]);
    }
  }, [assets, selectedAsset]);

  const fetchRate = async (from: string, to: string) => {
    // const res = await makeRequest.get("/exchange-rate/single", {
    //   params: { from, to },
    // });
    // return Number(res.data);
  };

  useEffect(() => {
    const loadRates = async () => {
      const uniqueCurrencies = [
        ...new Set(assets.map((a) => normalizeCurrency(a.currency ?? ""))),
      ];

      const results = await Promise.all(
        uniqueCurrencies.map(async (cur) => {
          try {
            const rate = await fetchRate(cur, "USD");
            return [cur, rate] as const;
          } catch (err) {
            console.error(`Failed rate for ${cur}`, err);
            return [cur, 0] as const;
          }
        }),
      );

      setRates(Object.fromEntries(results));
    };

    if (assets.length) loadRates();
  }, [assets]);

  if (isLoadingWallet) {
    return <Loader type="bounce" />;
  }
  if (isError) {
    return (
      <ErrorState
        onRetry={() => {
          refetch();
        }}
      />
    );
  }

  return (
    <div>
      <SwapContainer
        wallet={wallet!}
        assets={wallet?.assets ?? []}
        initialAsset={selectedAsset}
        isLoading={isLoading}
        onSwap={swap}
      />
    </div>
  );
};

export default AdminSwap;
